import React, { useState } from 'react';
import PropTypes from 'prop-types';
import mapNavConstantsToTitle from 'util/mapNavConstantsToTitle';
import NAV_DATA from '@zola-helpers/client/dist/es/constants/navConstants';
import NavContext from './context';
import useScrollPosition from '../../../hooks/useScrollPosition';

const defaultScrollPos = window.scrollY;

const NavScrollContainer = ({
  children,
  activeLinkId,
  disablePrimaryCollapse = false,
  disablePromoCollapse = false,
  emitDirectionEvent = false,
}) => {
  const [hidePrimarySection, setHidePrimarySection] = useState(
    !disablePrimaryCollapse && defaultScrollPos !== 0
  );
  const [hidePromoSection, setHidePromoSection] = useState(
    !disablePromoCollapse && defaultScrollPos !== 0
  );

  const { direction } = useScrollPosition(emitDirectionEvent);
  const isScrollingDown = direction === 'down';
  if (!disablePromoCollapse && isScrollingDown !== hidePromoSection) {
    setHidePromoSection(isScrollingDown);
  }
  if (!disablePrimaryCollapse && isScrollingDown !== hidePrimarySection) {
    setHidePrimarySection(isScrollingDown);
  }
  let finalLinkId = activeLinkId;
  if (
    !activeLinkId &&
    window &&
    window.location &&
    window.location.pathname.indexOf('/expert-advice') > -1
  ) {
    finalLinkId = NAV_DATA.PRIMARY.ADVICE;
  }
  const navContextValue = {
    activeLinkId: finalLinkId,
    hidePrimarySection,
    hidePromoSection,
    activeParent: mapNavConstantsToTitle(activeLinkId),
  };

  return <NavContext.Provider value={navContextValue}>{children}</NavContext.Provider>;
};

NavScrollContainer.propTypes = {
  children: PropTypes.node.isRequired,
  activeLinkId: PropTypes.string,
  disablePrimaryCollapse: PropTypes.bool,
  disablePromoCollapse: PropTypes.bool,
  emitDirectionEvent: PropTypes.bool,
};

export default NavScrollContainer;
